module.exports = __WEBPACK_EXTERNAL_MODULE_fs_promises_f8dae9d1__;